import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SlidingMenu, { SlidingMenuOption } from '../../general-components/sliding-menu';
import { GreenroomState as GS } from '../../../stores/types/types';
import ComingSoon from '../../general-components/coming-soon';
import ModeratorChat from '../../moderator-chat/moderator-chat';
import { TABS } from '../../../stores/types/tabs';
import { setActiveSubTab } from '../../../stores/actions/tabs';

export enum AudienceDrawerOptionTypes {
	Chat = 'Chat',
	Engage = 'Engage',
	Details = 'Details',
	Extras = 'Extras',
}

const audienceTabOptions = [
	{ label: AudienceDrawerOptionTypes.Chat },
	{ label: AudienceDrawerOptionTypes.Engage },
	{ label: AudienceDrawerOptionTypes.Details },
	{ label: AudienceDrawerOptionTypes.Extras },
];

export default function AudienceDrawer() {
	const dispatch = useDispatch();
	const { audience: audienceSubTab = AudienceDrawerOptionTypes.Chat } = useSelector(
		(state: GS) => state.TabsReducer.activeSubTabs,
	);
	const meeting = useSelector((state: GS) => state.SessionReducer.meeting);

	const selectedAudienceTab = useMemo(() => (
		audienceTabOptions.find((op: SlidingMenuOption) => op.label === audienceSubTab)
	), [audienceSubTab]);

	return (
		<div className="media-wrapper height-full audience-drawer">
			<div className="media-container flex-column">
				<SlidingMenu
					options={audienceTabOptions}
					selectedOption={selectedAudienceTab ?? audienceTabOptions[0]}
					callback={
						(option: SlidingMenuOption) => (
							dispatch(setActiveSubTab(TABS.AUDIENCE, option.label))
						)
					}
					className='position-relative width-calc-full'
					fullWidthDivider={true}
				/>
				{selectedAudienceTab?.label === AudienceDrawerOptionTypes.Chat && (
					<div className="audience-drawer-content audience-chat" >
						{meeting?.registration_on ? (
							<ModeratorChat />
						) : (
							<ComingSoon
								title='Registration off'
								body={
									'Registration must be turned on in the admin panel for chat to be seen inside of greenroom'
								}
							/>
						)}
					</div>
				)}
				{selectedAudienceTab?.label === AudienceDrawerOptionTypes.Engage && (
					<div className="audience-drawer-content audience-engage">
						< ComingSoon body={
							'Engage will let you manage and interact with your Q&A, Surveys, Polls and more'
						} />
					</div>
				)}
				{selectedAudienceTab?.label === AudienceDrawerOptionTypes.Details && (
					<div className="audience-drawer-content audience-details">
						<ComingSoon body={
							'Details will let you manage and view your segments and transcripts'
						} />
					</div>
				)}
				{selectedAudienceTab?.label === AudienceDrawerOptionTypes.Extras && (
					<div className="audience-drawer-content audience-extras">
						<ComingSoon body={
							'Extras will let you manage additional page content'
						} />
					</div>
				)}
			</div>
		</div>
	);
}
